import axios from 'axios';

export default ({ id }) => {
  const data = {
    ta6_submitted: true,
  };
  const saleData = Object.entries(data).reduce((a, [k, v]) => (v == null ? a : ((a[k] = v), a)), {});
  return axios.patch(`${process.env.VUE_APP_API_ENDPOINT}/sales/${id}`, saleData);
};
